import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}artikel`;

// Helper untuk mendapatkan token
const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    };
};

// Service untuk artikel dengan pagination
export const artikelService = {
    // Get all artikel dengan pagination
    getPaginate: async (queryString) => {
        try {
            const response = await axios.get(`${API_URL_WEB}/paginate?${queryString}`, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to fetch artikel',
                status: error.response?.status,
            };
        }
    },

    // Get all artikel (tanpa pagination - untuk kompatibilitas)
    getAll: async () => {
        try {
            const response = await axios.get(API_URL_WEB, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to fetch artikel',
            };
        }
    },

    // Get by ID
    getById: async (id) => {
        try {
            const response = await axios.get(`${API_URL_WEB}/${id}`, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to fetch artikel by ID',
            };
        }
    },

    // Create artikel
    create: async (artikelData) => {
        try {
            const response = await axios.post(API_URL_WEB, artikelData, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to create artikel',
                validationErrors: error.response?.data?.errors,
            };
        }
    },

    // Update artikel
    update: async (id, artikelData) => {
        try {
            const response = await axios.patch(`${API_URL_WEB}/${id}`, artikelData, getAuthHeader());
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to update artikel',
                validationErrors: error.response?.data?.errors,
            };
        }
    },

    // Delete artikel
    delete: async (id) => {
        try {
            await axios.delete(`${API_URL_WEB}/${id}`, getAuthHeader());
            return {
                success: true,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to delete artikel',
            };
        }
    },

    // Update active status
    updateActive: async (id, status) => {
        try {
            const response = await axios.patch(
                `${API_URL_WEB}/active-age-group/${id}`,
                { status },
                getAuthHeader()
            );
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to update active status',
            };
        }
    },
};

// Export untuk kompatibilitas dengan kode lama
export const getArtikels = () => {
    const token = localStorage.getItem('token');
    return axios.get(API_URL_WEB, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
};

export const getArtikelById = (id) => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
};

export const createArtikel = (artikel) => {
    const token = localStorage.getItem('token');
    return axios.post(API_URL_WEB, artikel, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
};

export const updateArtikel = (id, artikel) => {
    const token = localStorage.getItem('token');
    return axios.patch(`${API_URL_WEB}/${id}`, artikel, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
};

export const deleteArtikel = (id) => {
    const token = localStorage.getItem('token');
    return axios.delete(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export const updateActive = (id, status) => {
    const token = localStorage.getItem('token');
    return axios.patch(`${API_URL_WEB}/active-age-group/${id}`, { status }, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
    });
};